<script setup lang="ts"></script>

<template>
  <div class="skeleton">
    <div class="skeleton__card">
      <div class="skeleton__image skeleton-image"></div>
      <div class="skeleton__card-content">
        <div class="skeleton__line-1 skeleton-text"></div>
        <div class="skeleton__line-2 skeleton-text"></div>
        <div class="skeleton__line-3 skeleton-text"></div>
      </div>
    </div>
  </div>
</template>

<style lang="postcss">
.skeleton {
  .skeleton__card {
    width: 100%;
  }
  .skeleton__card-content {
    padding: var(--space-30);
    display: flex;
    flex-direction: column;
    gap: var(--space-30);
    background-color: transparent;
    .skeleton__line-1 {
      width: 40%;
    }
    .skeleton__line-2 {
      width: 100%;
    }
    .skeleton__line-3 {
      width: 70%;
      margin-top: var(--space-30);
    }
  }
}
</style>
